import s from "./styles";
import List from "../../components/common/ListWithMoreOptions";
import BottomPageSelectorWithPagination, {
  usePagination,
} from "../../components/common/BottomPageSelectorWithPagination";
import { usePaginatedData } from "../../helpers/hooks";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ClockInRowMap from "./Ins/ClockInRowMap";
import { useSessionClockIns } from "../../graphql/useClockIns";
import Loading from "components/common/loading";

const ClockInsTable = ({ clockSession, updateEnabled }) => {
  const { t } = useTranslation();

  const { sorting, setSorting, pagination, setPagination } =
    usePagination("name");

  const { clockIns, loading } = useSessionClockIns(clockSession._id);

  const actions = useMemo(
    () => ({
      in: t("containers.ClockSessions.in"),
      pause: t("containers.ClockSessions.pause"),
      resume: t("containers.ClockSessions.resume"),
      out: t("containers.ClockSessions.out"),
    }),
    []
  );

  const editableClockIns = useMemo(() => [...clockIns], [clockIns]);

  const employeeData = usePaginatedData(
    editableClockIns,
    pagination,
    sorting,
    undefined,
    undefined,
    // eslint-disable-next-line react/display-name
    (item) => () =>
      (
        <ClockInRowMap
          key={item._id}
          item={item}
          actions={actions}
          updateEnabled={updateEnabled}
        />
      )
  );
  const columns = useMemo(() => {
    return [
      {
        title: t("containers.ClockSessions.dateAndTime"),
        sortable: true,
        columnId: "updateDatetime",
      },
      {
        title: t("containers.ClockSessions.type"),
        sortable: true,
        columnId: "type",
      },
      {
        title: t("containers.ClockSessions.additionalInformation"),
        sortable: true,
        columnId: "notes",
      },
      {
        title: "",
      },
    ];
  }, []);

  return (
    <>
      <s.ListContainer>
        {loading ? (
          <Loading />
        ) : (
          <List
            width={"800px"}
            data={employeeData}
            columns={columns}
            sorting={sorting}
            moreOption={false}
            changeSorting={(columnId, order) => setSorting({ columnId, order })}
            tableStyle={{
              gridTemplateColumns: `8fr 8fr 6fr 4fr`,
            }}
          />
        )}
      </s.ListContainer>
      <BottomPageSelectorWithPagination
        pagination={pagination}
        setPagination={setPagination}
        length={employeeData.length}
      />
    </>
  );
};
export default ClockInsTable;
